import { SansText } from '../SansText/SansText'
import type { HorizontalCardDescriptionProps } from './HorizontalCardDescription.types'

export const HorizontalCardDescription = ({
  children,
  className,
}: HorizontalCardDescriptionProps & { className?: string }): JSX.Element => {
  return (
    <SansText className={className} as="span">
      {children}
    </SansText>
  )
}
